module.exports = __webpack_public_path__ + "static/img/ram-icon.b3be3995.gif";